import React, { useState } from "react";
import styles from "./AddDeposit.module.css";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";
import { FaUserPlus } from "react-icons/fa";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";

import HeadingAndData from "../../components/HeadingAndData/HeadingAndData";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import ToClose from "../../components/ToClose/ToClose";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import CheckboxAndData from "../../components/CheckboxAndData/CheckboxAndData";
import CalendarInput from "../../components/CalendarInput/CalendarInput";
import { IoDocumentTextOutline } from "react-icons/io5";

const AddDeposit = () => {
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [search, setSearch] = useState("");

  const dummyStudents = [
    { id: "s1", name: "John" },
    { id: "s2", name: "Steeve" },
    { id: "s3", name: "John" },
    { id: "s4", name: "Steeve" },
    { id: "s5", name: "John" },
    { id: "s6", name: "Steeve" },
    { id: "s7", name: "John" },
    { id: "s8", name: "Steeve" },
    { id: "s9", name: "John" },
    { id: "s10", name: "Steeve" },
  ];

  const handleStudentCheckbox = (id) => {
    setSelectedStudents((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const filteredStudents = dummyStudents.filter((student) =>
    student.name.toLowerCase().includes(search.toLowerCase())
  );

  const dispatch = useDispatch();

  const [form, setForm] = useState({
    amount: "",
    date: "",
    approvedBy: "",
    reason: "",
    sendToParent: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckbox = (e) => {
    setForm((prev) => ({ ...prev, sendToParent: e.target.checked }));
  };

  const handleSave = () => {
    dispatch(closeModal());
  };

  const handleCancel = () => dispatch(closeModal());

  return (
    <div className={styles.modalWrapper}>
      <div className={styles.heading}>
        <HeadingAndIcon
          icon={<IoDocumentTextOutline />}
          heading="Add Deposit"
          color="var(--Primary_Color)"
        />
        <ToClose onClose={() => dispatch(closeModal())} />
      </div>

      <div className={styles.totaldata}>
        <div className={styles.subheading}>
          <HeadingAndIcon
            icon={<IoDocumentTextOutline />}
            heading="Deposit Details"
            color="var(--Primary_Color)"
          />
        </div>

        <div className={styles.content}>
          <div className={styles.formGrid}>
            <HeadingAndData
              label="Deposit Amount"
              name="amount"
              placeholder="Enter deposit amount"
              value={form.amount}
              onChange={handleChange}
              required
            />

            <CalendarInput
              fieldLabel="Date"
              required
              value={form.date}
              onChange={(date) => setForm((prev) => ({ ...prev, date }))}
            />

            <HeadingAndDropDown
              label="Approved by"
              name="approvedBy"
              value={form.approvedBy}
              onChange={handleChange}
              options={[
                { label: "Staff A", value: "staffA" },
                { label: "Staff B", value: "staffB" },
              ]}
            />
          </div>

          <div className={styles.reasonWrapper}>
            <label className={styles.reasonLabel} htmlFor="reason">
              Reason
            </label>
            <textarea
              id="reason"
              name="reason"
              placeholder="Enter reason here"
              className={styles.textareaField}
              value={form.reason}
              onChange={handleChange}
            />
          </div>

          <div className={styles.bottomRow}>
            <CheckboxAndData
              label="Send Details to parent"
              checked={form.sendToParent}
              onChange={handleCheckbox}
              labelColor="#888"
            />

            <SaveAndCancel onSave={handleSave} onCancel={handleCancel} />
          </div>
        </div>
      </div>

      <div className={styles.sectionCard}>
        <div className={styles.sectionHeader}>
          <HeadingAndIcon icon={<FaUserPlus />} heading="Assign Student" />
        </div>
        <div className={styles.studentdata}>
          <div className={styles.controls}>
            <SearchBar
              placeholder="Search Student"
              onChange={(e) => setSearch(e.target.value)}
            />
            <Dropdown
              bgColor="var(--Utility_Color9)"
              label="Room"
              options={["Room A", "Room B"]}
            />
          </div>

          <div className={styles.listHeader}>
            <CheckboxAndData
              checked={selectedStudents.length === filteredStudents.length}
              onChange={(e) =>
                setSelectedStudents(
                  e.target.checked ? filteredStudents.map((s) => s.id) : []
                )
              }
              label={"Select All"}
              checkboxSize={14}
              labelSize={16}
            />
            <span>{selectedStudents.length} Selected</span>
          </div>

          <div className={styles.grid}>
            {filteredStudents.map((student) => (
              <CheckboxAndData
                key={student.id}
                checked={selectedStudents.includes(student.id)}
                onChange={() => handleStudentCheckbox(student.id)}
                label={student.name}
                checkboxSize={14}
                labelColor="var(--Primary_Color)"
                labelSize={16}
              />
            ))}
          </div>

          <div className={styles.footerActions}>
            <SaveAndCancel onSave={handleSave} onCancel={handleCancel} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddDeposit;
